import React from 'react';
import { Box, Button, CircularProgress, Stack, useTheme } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import PartnerForm from '../components/PartnerForm';
import { useGetPartnerHandler } from '../dataHandlers/getPartnerHandler';
import TopBar from '../../../components/TopBar';

export default function PartnerDetailsPage() {
  const navigate = useNavigate();
  const { id } = useParams();
  const theme = useTheme();
  const { partner, isLoading } = useGetPartnerHandler(id);

  function onClickingBackButton() {
    return navigate('/partners');
  }

  if (isLoading || !partner) return <CircularProgress />;

  return (
    <Stack direction="column" sx={{ mt: '-1rem' }}>
      <Box>
        <TopBar title="Partner Details" subTitle={partner?.id} identifier={partner?.id}>
          <Button
            data-testid="partner-profile-back-button"
            key="back"
            variant="contained"
            color="primary"
            onClick={onClickingBackButton}
            className="action-button"
            sx={{ marginLeft: theme.spacing(1) }}
          >
            Back
          </Button>
        </TopBar>
      </Box>
      <PartnerForm initialData={partner} readOnly={true} edit={false} onCancel={() => navigate('/partners')} />
    </Stack>
  );
}
